// Translations for DE, EN, IT
const translations = {
  de: {
    // Nav
    nav_home: "Startseite",
    nav_menu: "Speisekarte",
    nav_reservation: "Reservierung",
    nav_order: "Online bestellen",
    nav_reviews: "Bewertungen",
    nav_about: "Über uns",
    nav_contact: "Kontakt",
    nav_admin: "Admin",
    nav_lieferando: "Lieferando",
    // Hero
    hero_cta_reserve: "Tisch reservieren",
    hero_cta_order: "Online bestellen",
    hero_cta_menu: "Speisekarte ansehen",
    hero_cta_lieferando: "Lieferando bestellen",
    // General
    opening_hours: "Öffnungszeiten",
    closed: "Geschlossen",
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
    address: "Adresse",
    phone: "Telefon",
    email: "E-Mail",
    our_menu: "Unsere Speisekarte",
    house_recommendation: "Empfehlung des Hauses",
    reviews_title: "Was unsere Gäste sagen",
    google_reviews: "Google Bewertungen",
    location_contact: "Anfahrt & Kontakt",
    about_us: "Über uns",
    contact_us: "Kontakt",
    impressum: "Impressum",
    privacy: "Datenschutz",
    all_rights: "Alle Rechte vorbehalten",
    // Reservation
    reservation_title: "Tisch reservieren",
    reservation_subtitle: "Reservieren Sie Ihren Tisch für ein unvergessliches Erlebnis",
    date: "Datum",
    time: "Uhrzeit",
    party_size: "Anzahl Personen",
    name: "Name",
    phone_number: "Telefonnummer",
    email_address: "E-Mail-Adresse",
    notes: "Bemerkung (optional)",
    submit_reservation: "Reservierung absenden",
    reservation_success: "Ihre Reservierung wurde erfolgreich aufgenommen!",
    reservation_confirmed: "Reservierung bestätigt",
    reservation_thank_you: "Vielen Dank! Wir freuen uns auf Ihren Besuch.",
    // Ordering
    order_title: "Online bestellen",
    order_subtitle: "Bestellen Sie Ihre Lieblingsgerichte bequem von zu Hause",
    add_to_cart: "In den Warenkorb",
    cart: "Warenkorb",
    cart_empty: "Ihr Warenkorb ist leer",
    checkout: "Zur Kasse",
    pickup: "Abholung",
    delivery: "Lieferung",
    your_order: "Ihre Bestellung",
    total: "Gesamt",
    place_order: "Bestellung aufgeben",
    order_success: "Ihre Bestellung wurde erfolgreich aufgegeben!",
    order_confirmed: "Bestellung bestätigt",
    order_thank_you: "Vielen Dank für Ihre Bestellung!",
    customer_name: "Name",
    customer_phone: "Telefonnummer",
    customer_email: "E-Mail (optional)",
    delivery_address: "Lieferadresse",
    pay_on: "Bezahlung bei",
    pay_pickup: "Bezahlung bei Abholung",
    pay_delivery: "Bezahlung bei Lieferung",
    items: "Artikel",
    remove: "Entfernen",
    // Reviews
    reviews_page_title: "Bewertungen unserer Gäste",
    reviews_page_subtitle: "Erfahren Sie, was unsere Gäste über uns sagen",
    based_on: "basierend auf",
    reviews_count: "Bewertungen",
    // About
    about_title: "Über Little Italy",
    about_subtitle: "Ein Stück Italien im Herzen von Eberbach",
    // Contact
    contact_title: "Kontakt",
    contact_subtitle: "Wir freuen uns auf Ihre Nachricht",
    visit_us: "Besuchen Sie uns",
    get_directions: "Route planen",
    // Lieferando
    lieferando_text: "Jetzt auch über Lieferando bestellen",
    lieferando_cta: "Bei Lieferando bestellen",
    // Admin
    admin_login: "Admin Login",
    admin_dashboard: "Dashboard",
    admin_menu_mgmt: "Speisekarte",
    admin_orders: "Bestellungen",
    admin_reservations: "Reservierungen",
    admin_reviews: "Bewertungen",
    admin_settings: "Einstellungen",
    logout: "Abmelden",
    password: "Passwort",
    login: "Anmelden",
    // Categories
    categories: "Kategorien",
    all_categories: "Alle Kategorien",
    popular_dishes: "Beliebte Gerichte",
    // Footer
    follow_us: "Folgen Sie uns",
    // Misc
    back_to_home: "Zurück zur Startseite",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    search: "Suchen",
    filter: "Filtern",
    status: "Status",
    new_status: "Neu",
    confirmed: "Bestätigt",
    completed: "Abgeschlossen",
    cancelled: "Storniert",
    today: "Heute",
    revenue: "Umsatz",
    person: "Person",
    persons: "Personen",
    select_time: "Uhrzeit wählen",
    select_date: "Datum wählen",
    first_name: "Vorname",
    last_name: "Nachname",
    whatsapp_confirm_reservation: "Reservierung per WhatsApp bestätigen",
    whatsapp_confirm_order: "Bestellung per WhatsApp bestätigen",
    placeholder_notes: "Besondere Wünsche, Allergien, Anlass...",
    error_fill_fields: "Bitte füllen Sie alle Pflichtfelder aus.",
    error_generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    message_sent: "Nachricht gesendet!",
    message_sent_subtitle: "Wir melden uns in Kürze bei Ihnen.",
    send_message: "Nachricht senden",
    write_us: "Schreiben Sie uns",
    message: "Nachricht",
    optional: "optional",
    dishes_count: "Gerichte in 8 Kategorien",
    cancel_reservation: "Reservierung stornieren",
    cancel_question: "Möchten Sie Ihre Reservierung wirklich absagen?",
    cancel_warning: "Bitte beachten Sie: Diese Aktion kann nicht rückgängig gemacht werden.",
    cancel_confirm: "Ja, Reservierung stornieren",
    cancel_deny: "Nein, doch nicht stornieren",
    cancel_success: "Reservierung storniert",
    cancel_success_text: "Ihre Reservierung wurde erfolgreich storniert.",
    cancel_success_subtitle: "Schade, dass Sie nicht kommen können. Wir freuen uns auf Ihren nächsten Besuch!",
    rebook: "Neu reservieren",
    cancelling: "Wird storniert...",
    reservation_not_found: "Reservierung nicht gefunden",
    reservation_not_found_text: "Der Stornierungslink ist ungültig oder die Reservierung existiert nicht mehr.",
    your_reservation: "Ihre Reservierung",
    to_homepage: "Zur Startseite",
  },
  en: {
    nav_home: "Home",
    nav_menu: "Menu",
    nav_reservation: "Reservation",
    nav_order: "Order Online",
    nav_reviews: "Reviews",
    nav_about: "About Us",
    nav_contact: "Contact",
    nav_admin: "Admin",
    nav_lieferando: "Lieferando",
    hero_cta_reserve: "Reserve a table",
    hero_cta_order: "Order online",
    hero_cta_menu: "View menu",
    hero_cta_lieferando: "Order via Lieferando",
    opening_hours: "Opening Hours",
    closed: "Closed",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    address: "Address",
    phone: "Phone",
    email: "Email",
    our_menu: "Our Menu",
    house_recommendation: "Chef's Recommendation",
    reviews_title: "What our guests say",
    google_reviews: "Google Reviews",
    location_contact: "Location & Contact",
    about_us: "About Us",
    contact_us: "Contact",
    impressum: "Legal Notice",
    privacy: "Privacy Policy",
    all_rights: "All rights reserved",
    reservation_title: "Reserve a Table",
    reservation_subtitle: "Reserve your table for an unforgettable experience",
    date: "Date",
    time: "Time",
    party_size: "Party Size",
    name: "Name",
    phone_number: "Phone Number",
    email_address: "Email Address",
    notes: "Notes (optional)",
    submit_reservation: "Submit Reservation",
    reservation_success: "Your reservation has been successfully submitted!",
    reservation_confirmed: "Reservation Confirmed",
    reservation_thank_you: "Thank you! We look forward to your visit.",
    order_title: "Order Online",
    order_subtitle: "Order your favorite dishes from the comfort of your home",
    add_to_cart: "Add to cart",
    cart: "Cart",
    cart_empty: "Your cart is empty",
    checkout: "Checkout",
    pickup: "Pickup",
    delivery: "Delivery",
    your_order: "Your Order",
    total: "Total",
    place_order: "Place Order",
    order_success: "Your order has been successfully placed!",
    order_confirmed: "Order Confirmed",
    order_thank_you: "Thank you for your order!",
    customer_name: "Name",
    customer_phone: "Phone Number",
    customer_email: "Email (optional)",
    delivery_address: "Delivery Address",
    pay_on: "Pay on",
    pay_pickup: "Pay on pickup",
    pay_delivery: "Pay on delivery",
    items: "Items",
    remove: "Remove",
    reviews_page_title: "Guest Reviews",
    reviews_page_subtitle: "See what our guests say about us",
    based_on: "based on",
    reviews_count: "reviews",
    about_title: "About Little Italy",
    about_subtitle: "A piece of Italy in the heart of Eberbach",
    contact_title: "Contact",
    contact_subtitle: "We look forward to hearing from you",
    visit_us: "Visit Us",
    get_directions: "Get Directions",
    lieferando_text: "Now also available on Lieferando",
    lieferando_cta: "Order on Lieferando",
    admin_login: "Admin Login",
    admin_dashboard: "Dashboard",
    admin_menu_mgmt: "Menu",
    admin_orders: "Orders",
    admin_reservations: "Reservations",
    admin_reviews: "Reviews",
    admin_settings: "Settings",
    logout: "Logout",
    password: "Password",
    login: "Login",
    categories: "Categories",
    all_categories: "All Categories",
    popular_dishes: "Popular Dishes",
    follow_us: "Follow Us",
    back_to_home: "Back to Home",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filter: "Filter",
    status: "Status",
    new_status: "New",
    confirmed: "Confirmed",
    completed: "Completed",
    cancelled: "Cancelled",
    today: "Today",
    revenue: "Revenue",
    person: "Person",
    persons: "Persons",
    select_time: "Select time",
    select_date: "Select date",
    first_name: "First Name",
    last_name: "Last Name",
    whatsapp_confirm_reservation: "Confirm reservation via WhatsApp",
    whatsapp_confirm_order: "Confirm order via WhatsApp",
    placeholder_notes: "Special requests, allergies, occasion...",
    error_fill_fields: "Please fill in all required fields.",
    error_generic: "An error occurred. Please try again.",
    message_sent: "Message sent!",
    message_sent_subtitle: "We will get back to you shortly.",
    send_message: "Send Message",
    write_us: "Send us a Message",
    message: "Message",
    optional: "optional",
    dishes_count: "dishes across 8 categories",
    cancel_reservation: "Cancel Reservation",
    cancel_question: "Would you like to cancel your reservation?",
    cancel_warning: "Please note: This action cannot be undone.",
    cancel_confirm: "Yes, cancel reservation",
    cancel_deny: "No, keep my reservation",
    cancel_success: "Reservation cancelled",
    cancel_success_text: "Your reservation has been successfully cancelled.",
    cancel_success_subtitle: "We're sorry you can't make it. We look forward to your next visit!",
    rebook: "Book again",
    cancelling: "Cancelling...",
    reservation_not_found: "Reservation not found",
    reservation_not_found_text: "The cancellation link is invalid or the reservation no longer exists.",
    your_reservation: "Your Reservation",
    to_homepage: "Go to Homepage",
  },
  it: {
    nav_home: "Home",
    nav_menu: "Menù",
    nav_reservation: "Prenotazione",
    nav_order: "Ordina Online",
    nav_reviews: "Recensioni",
    nav_about: "Chi Siamo",
    nav_contact: "Contatti",
    nav_admin: "Admin",
    nav_lieferando: "Lieferando",
    hero_cta_reserve: "Prenota un tavolo",
    hero_cta_order: "Ordina online",
    hero_cta_menu: "Vedi il menù",
    hero_cta_lieferando: "Ordina su Lieferando",
    opening_hours: "Orari di Apertura",
    closed: "Chiuso",
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    sunday: "Domenica",
    address: "Indirizzo",
    phone: "Telefono",
    email: "Email",
    our_menu: "Il Nostro Menù",
    house_recommendation: "Raccomandazione dello Chef",
    reviews_title: "Cosa dicono i nostri ospiti",
    google_reviews: "Recensioni Google",
    location_contact: "Come Raggiungerci",
    about_us: "Chi Siamo",
    contact_us: "Contatti",
    impressum: "Avviso Legale",
    privacy: "Privacy",
    all_rights: "Tutti i diritti riservati",
    reservation_title: "Prenota un Tavolo",
    reservation_subtitle: "Prenota il tuo tavolo per un'esperienza indimenticabile",
    date: "Data",
    time: "Ora",
    party_size: "Numero di Persone",
    name: "Nome",
    phone_number: "Numero di Telefono",
    email_address: "Indirizzo Email",
    notes: "Note (opzionale)",
    submit_reservation: "Invia Prenotazione",
    reservation_success: "La tua prenotazione è stata inviata con successo!",
    reservation_confirmed: "Prenotazione Confermata",
    reservation_thank_you: "Grazie! Non vediamo l'ora di accogliervi.",
    order_title: "Ordina Online",
    order_subtitle: "Ordina i tuoi piatti preferiti comodamente da casa",
    add_to_cart: "Aggiungi al carrello",
    cart: "Carrello",
    cart_empty: "Il tuo carrello è vuoto",
    checkout: "Cassa",
    pickup: "Ritiro",
    delivery: "Consegna",
    your_order: "Il Tuo Ordine",
    total: "Totale",
    place_order: "Effettua Ordine",
    order_success: "Il tuo ordine è stato effettuato con successo!",
    order_confirmed: "Ordine Confermato",
    order_thank_you: "Grazie per il tuo ordine!",
    customer_name: "Nome",
    customer_phone: "Numero di Telefono",
    customer_email: "Email (opzionale)",
    delivery_address: "Indirizzo di Consegna",
    pay_on: "Pagamento alla",
    pay_pickup: "Pagamento al ritiro",
    pay_delivery: "Pagamento alla consegna",
    items: "Articoli",
    remove: "Rimuovi",
    reviews_page_title: "Recensioni dei Nostri Ospiti",
    reviews_page_subtitle: "Scopri cosa dicono i nostri ospiti di noi",
    based_on: "basato su",
    reviews_count: "recensioni",
    about_title: "Chi è Little Italy",
    about_subtitle: "Un pezzo d'Italia nel cuore di Eberbach",
    contact_title: "Contatti",
    contact_subtitle: "Non vediamo l'ora di sentirvi",
    visit_us: "Vieni a Trovarci",
    get_directions: "Indicazioni",
    lieferando_text: "Ora disponibile anche su Lieferando",
    lieferando_cta: "Ordina su Lieferando",
    admin_login: "Accesso Admin",
    admin_dashboard: "Dashboard",
    admin_menu_mgmt: "Menù",
    admin_orders: "Ordini",
    admin_reservations: "Prenotazioni",
    admin_reviews: "Recensioni",
    admin_settings: "Impostazioni",
    logout: "Esci",
    password: "Password",
    login: "Accedi",
    categories: "Categorie",
    all_categories: "Tutte le Categorie",
    popular_dishes: "Piatti Popolari",
    follow_us: "Seguici",
    back_to_home: "Torna alla Home",
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    search: "Cerca",
    filter: "Filtra",
    status: "Stato",
    new_status: "Nuovo",
    confirmed: "Confermato",
    completed: "Completato",
    cancelled: "Annullato",
    today: "Oggi",
    revenue: "Fatturato",
    person: "Persona",
    persons: "Persone",
    select_time: "Seleziona ora",
    select_date: "Seleziona data",
    first_name: "Nome",
    last_name: "Cognome",
    whatsapp_confirm_reservation: "Conferma prenotazione via WhatsApp",
    whatsapp_confirm_order: "Conferma ordine via WhatsApp",
    placeholder_notes: "Richieste speciali, allergie, occasione...",
    error_fill_fields: "Si prega di compilare tutti i campi obbligatori.",
    error_generic: "Si è verificato un errore. Riprova.",
    message_sent: "Messaggio inviato!",
    message_sent_subtitle: "Vi risponderemo al più presto.",
    send_message: "Invia Messaggio",
    write_us: "Scrivici un Messaggio",
    message: "Messaggio",
    optional: "opzionale",
    dishes_count: "piatti in 8 categorie",
    cancel_reservation: "Annulla Prenotazione",
    cancel_question: "Desiderate annullare la vostra prenotazione?",
    cancel_warning: "Attenzione: questa azione non può essere annullata.",
    cancel_confirm: "Sì, annulla la prenotazione",
    cancel_deny: "No, mantieni la prenotazione",
    cancel_success: "Prenotazione annullata",
    cancel_success_text: "La vostra prenotazione è stata annullata con successo.",
    cancel_success_subtitle: "Ci dispiace che non possiate venire. Vi aspettiamo alla prossima visita!",
    rebook: "Prenota di nuovo",
    cancelling: "Annullamento in corso...",
    reservation_not_found: "Prenotazione non trovata",
    reservation_not_found_text: "Il link di annullamento non è valido o la prenotazione non esiste più.",
    your_reservation: "La Vostra Prenotazione",
    to_homepage: "Vai alla Homepage",
  }
};

export default translations;
